import PropTypes from "prop-types";
import React, { useCallback } from "react";
import { ButtonCompo } from "../../../components/Comman/Button";
import TypographyCompo from "../../../components/Comman/TypographyCompo";
import offerImg from "../../../Images/offer.png";

const BillingPreviewAppliedOfferChip = ({
	offerId,
	offerName,
	offerIndex,
	onOfferDetailClick,
}) => {
	const handleClick = useCallback(() => {
		onOfferDetailClick(offerId);
	}, [onOfferDetailClick, offerId]);

	return (
		<ButtonCompo
			type="button"
			variant="text"
			className="billing-preview-offer-chip"
			name={
				<>
					<TypographyCompo
						component="span"
						className="billing-preview-offer-chip-index"
					>
						{offerIndex + 1}
					</TypographyCompo>
					<img src={offerImg} alt="" className="billing-preview-offer-chip-img" />
					<TypographyCompo
						component="span"
						className="billing-preview-offer-chip-name"
					>
						{offerName || ""}
					</TypographyCompo>
					<TypographyCompo
						component="span"
						className="billing-preview-offer-chip-action"
					>
						View
					</TypographyCompo>
				</>
			}
			onClick={handleClick}
		/>
	);
};

BillingPreviewAppliedOfferChip.propTypes = {
	offerId: PropTypes.string.isRequired,
	offerName: PropTypes.string,
	offerIndex: PropTypes.number.isRequired,
	onOfferDetailClick: PropTypes.func.isRequired,
};

export default React.memo(BillingPreviewAppliedOfferChip);
